export default __webpack_public_path__ + "static/media/homestead_thumb.ee0cf88b.png";